exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".export-section {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  min-width: 400px; }\n\n.date-range-section {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  gap: 15px;\n  margin-top: 10px; }\n\n.datepicker,\n.company-select {\n  width: 100%; }\n\n.loading-info {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n  color: #2196f3; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/DocumentsModule/DocumentExportDialogComponent/document-export.dialog.component.scss
// module id = ../../../../../src/DocumentsModule/DocumentExportDialogComponent/document-export.dialog.component.scss
// module chunks = main